<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :validate-on-rule-change="false"
      size="mini"
    >
      <h6 style="color: #101010;">
        {{ $l('form_label_base') || '基本信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_designer') || '业务人员'"
            prop="designerCode"
          >
            <dict-select
              v-model="formData.designerCode"
              :selectedLabel.sync="formData.designerName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '下单日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_finishDate') || '要求完成日期'"
            prop="finishDate"
          >
            <el-date-picker
              v-model="formData.finishDate"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_expensePayerCode') || '付款公司'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :body="{ dictType: 'expensePayer' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :selectedLabel.sync="formData.expensePayerName"
              filterable
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_cust') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.custName"
              filterable
              clearable
              size="mini"
              style="width: 100%"
              @change="custChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custContact') || '客户联系人'"
            prop="custContact"
          >
            <el-input
              v-model="formData.custContact"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custContactPhone') || '客户联系人电话'"
          >
            <el-input
              v-model="formData.custContactPhone"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_custContactEmail') || '客户联系人邮箱'"
          >
            <el-input
              v-model="formData.custContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scm') || '打样工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.scmName"
              filterable
              clearable
              size="mini"
              style="width: 100%"
              @change="scmChange"
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_scmContact') || '工厂联系人'"
            prop="scmContact"
          >
            <el-input
              v-model="formData.scmContact"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_scmContactsPhone') || '工厂联系人电话'"
            prop="scmContactsPhone"
          >
            <el-input
              v-model="formData.scmContactsPhone"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scmContactsEmail') || '工厂联系人邮箱'"
          >
            <el-input
              v-model="formData.scmContactsEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_proofingUse') || '样品用途'"
            prop="proofingUse"
          >
            <dict-select
              v-model="formData.proofingUse"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sampleSource' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_sampleSalesSeason') || '开发季节'"
            prop="sampleSalesSeason"
          >
            <dict-select
              v-model="formData.sampleSalesSeason"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sampleSalesSeason' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_custProjectNo') || '客户项目号'">
            <el-input
              v-model="formData.custProjectNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalQty') || '样品总数量'">
            <el-input v-model="formData.totalQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_sampleAmount') || '样品费用'">
            <el-input v-model="formData.sampleAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_addSurcharge') || '附加费用'">
            <el-input v-model="formData.addSurcharge" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_category') || '打样产品分类'"
            prop="categoryCode"
          >
            <CategoryCascader
              :disabled="disabled"
              :categoryCode.sync="formData.categoryCode"
              :categoryName.sync="formData.categoryName"
              :masterCategoryCode.sync="formData.masterCategoryCode"
              :masterCategoryName.sync="formData.masterCategoryName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_dep') || '费用分摊部门'"
            prop="depCode"
          >
            <dep-cascader
              size="mini"
              :lastValue.sync="formData.depCode"
              :valueString.sync="formData.displayDepCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalAmount') || '费用合计'">
            <el-input v-model="formData.totalAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 style="color: #101010;" class="my-2">
        {{ $l('form_label_tech') || '工艺要求及备注说明' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_techDescription') || '工艺要求'"
            prop="techDescription"
          >
            <el-input
              v-model="formData.techDescription"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_proofingRemark') || '备注说明'">
            <el-input
              v-model="formData.proofingRemark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 style="color: #101010;" class="my-2">
        {{ $l('form_label_deliveryInfo') || '样品寄送信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_consignees') || '样品收货人'"
            prop="consignees"
          >
            <el-input
              v-model="formData.consignees"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_consigneesPhone') || '收货人电话'"
            prop="consigneesPhone"
          >
            <el-input
              v-model="formData.consigneesPhone"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_deliveryAddress') || '样品寄送地址'"
            prop="deliveryAddress"
          >
            <el-input
              v-model="formData.deliveryAddress"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <ChooseCustomerContacts
      :visible.sync="chooseCustomerContactsVisible"
      :title="`${formData.custName} ${$l('dialog_title_contacts') || '联系人'}`"
      :custCode="formData.custCode"
      @confirm="customerContactsConfirm"
    />

    <ChooseScmContacts
      :visible.sync="chooseScmContactsVisible"
      :title="`${formData.scmName} ${$l('dialog_title_contacts') || '联系人'}`"
      :scmCode="formData.scmCode"
      @confirm="scmContactsConfirm"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import CategoryCascader from '../category-cascader'
import ChooseCustomerContacts from '@/views/digital/components/choose-customer-contacts'
import ChooseScmContacts from '@/views/digital/components/choose-scm-contacts'
export default {
  components: { CategoryCascader, ChooseCustomerContacts, ChooseScmContacts },
  mixins: [EditLoading],
  props: {
    proofingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        requestDate: dayjs().format('YYYY-MM-DD'),
        currencyUnit: 'CNY',
        custContact: '',
        custContactPhone: '',
        custContactEmail: '',
        scmContact: '',
        scmContactsPhone: '',
        scmContactsEmail: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        designerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        finishDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        custContact: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmContact: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        scmContactsPhone: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        proofingUse: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        sampleSalesSeason: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        techDescription: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        consignees: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        consigneesPhone: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        deliveryAddress: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      chooseCustomerContactsVisible: false,
      chooseScmContactsVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  watch: {
    userInfo: {
      handler() {
        if (this.proofingCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo || {}
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.proofingCode) return
      const data = await this.$api
        .customerProofingDetailApi({ proofingCode: this.proofingCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.formData = data
      this.$emit('loaded', { ...data })
    },
    async reload() {
      if (!this.proofingCode) return
      const data = await this.$api
        .customerProofingDetailApi({ proofingCode: this.proofingCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return

      this.$emit('loaded', data)
    },
    async custChange(custCode) {
      if (!custCode) return

      const res = await this.$api
        .masterCustomerContactsListApi({ custCode })
        .catch(() => null)
      if (!res) return

      const data = res.body.data

      if (!data?.length) return
      if (data.length > 1) return (this.chooseCustomerContactsVisible = true)

      this.customerContactsConfirm(data[0])
    },
    customerContactsConfirm(data) {
      this.formData.custContact = data.contactName
      this.formData.custContactPhone = data.contactMobile
      this.formData.custContactEmail = data.contactEmail
    },
    async scmChange(scmCode) {
      if (!scmCode) return

      const res = await this.$api
        .scmInfoContactsListApi({ scmCode })
        .catch(() => null)
      if (!res) return

      const data = res.body.data

      if (!data?.length) return
      if (data.length > 1) return (this.chooseScmContactsVisible = true)

      this.scmContactsConfirm(data[0])
    },
    scmContactsConfirm(data) {
      this.formData.scmContact = data.contactName
      this.formData.scmContactsPhone = data.contactMobile
      this.formData.scmContactsEmail = data.contactEmail
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerProofingSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status, body } = res
      if (status !== 200 || !body) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.proofingCode && !this.isCopy) return this.getData()

      const { proofingCode, proofingNo } = body
      this.$router.replace({
        name: 'customerManage-proofingRecord-detail',
        params: { proofingCode, pageType: 'edit' },
        query: { proofingNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input-number .el-input__inner {
    text-align: start;
  }
}
</style>
